export default __webpack_public_path__ + "static/site-icon-1f368be3f8846771008ffce4f2391e1f.png";